<template lang="pug">
    Upload(
        :format="formItem.handleUpload.format"
        :on-error="uploadfail"
        :on-success="uploadsuccess"
        :before-upload="uploadbefore"
        name="uploads"
        ref="uploads"
        :webkitdirectory="formItem.handleUpload.webkitdirectory || false"
        :multiple="formItem.handleUpload.multiple || false"
        :action="`/api/uploads/${formItem.uploadEndPoint}`"
        :show-upload-list="formItem.handleUpload.showUploadList || false"
        :on-format-error="handleFormatError"
        :data="formData"
        v-bind:with-credentials="true")
        Button(
            icon="ios-cloud-upload-outline"
            style="width: 100%;") {{formItem.handleUpload.format | arrayToString}}
        br
        span {{ value }}
</template>
<script>
export default {
    props: ["formData", "formItem", "value"],
    methods: {
        uploadbefore(file) {
            if (this.formItem.handleUpload.hasbeforeUpdateFields) {
                var self = this;
                // console.log(file);
                let read = new FileReader();
                read.readAsBinaryString(file);
                read.onloadend = function () {
                    let bufStr = read.result;
                    let buffer = Buffer.from(bufStr);
                    let name = file.webkitRelativePath || file.name;
                    if (!self.formData["directoryPath"]) {
                        self.formData["directoryPath"] = [{ name, size: file.size, buffer }];
                    } else {
                        self.formData["directoryPath"].push({ name, size: file.size, buffer });
                    }

                    if (file.webkitRelativePath == "") {
                        self.formData[self.formItem.key] = file.name;
                    } else {
                        if (self.formData[self.formItem.key] == "") {
                            self.formData[self.formItem.key] = [file.webkitRelativePath];
                        } else {
                            self.formData[self.formItem.key].push(file.webkitRelativePath);
                        }
                    }
                };
                this.$Notice.success({
                    title: this.$t("global.uploadSuccess"),
                    desc: `上傳成功`,
                });
            }
            return !this.formItem.handleUpload.hasbeforeUpdateFields;
        },
        uploadfail(error, response, fileList) {
            if (error.status == 413) {
                return this.$Notice.warning({
                    title: "失敗",
                    desc: "Exceed file size limit.",
                });
            }
            var filename = response.uploadname;
            this.formData[filename] = "";
            this.$Notice.warning({
                title: "檔案錯誤",
                desc: `${response.message}`,
            });
        },
        uploadsuccess(response, file, fileList) {
            // response 即是 file.response
            // 找到上傳的欄位配置
            // var fieldItem = this.formDataSetup.find(e => e.bindCol == file.response.uploadname);
            if (response.success == false) {
                // 更新指定欄位
                this.formItem.handleUpload.successUpdateFields.forEach((key) => {
                    this.formData[key] = "";
                });
                return this.$Notice.warning({
                    title: "檔案錯誤",
                    desc: `${response.message}`,
                });
            } else {
                // 更新指定欄位
                this.formItem.handleUpload.successUpdateFields.forEach((key) => {
                    this.formData[key] = response.uploadPerformResult[key];
                });
            }
            // 傳送本欄位更新事件
            this.$emit("input", response.uploadPerformResult[this.formItem.key]);

            this.$Notice.success({
                title: this.$t("global.uploadSuccess"),
                desc: `${response.message}`,
            });
            if (typeof this.formItem.handleUpload.successAction == "function") {
                this.formItem.handleUpload.successAction();
            }
        },
        handleFormatError(file) {
            this.$Notice.warning({
                title: this.$t("global.errorFile"),
                desc: `${file.name} ` + this.$t("rcmtable.validateUnsupportedText"),
            });
        },
    },
    filters: {
        arrayToString: function (text) {
            return Array.isArray(text) ? text.join(", ") : text;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/Upload.vue